export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';

export const SET_CBODY_CLASS = 'SET_CBODY_CLASS';

export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const ADD_BREADCRUMB = 'ADD_BREADCRUMB';
export const CLEAR_BREADCRUMB = 'CLEAR_BREADCRUMB';

export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const GET_ME_REQUEST = 'GET_ME_REQUEST';
export const GET_ME_SUCCESS = 'GET_ME_SUCCESS';
export const GET_ME_FAILURE = 'GET_ME_FAILURE';

export const PUT_ME_REQUEST = 'PUT_ME_REQUEST';
export const PUT_ME_SUCCESS = 'PUT_ME_SUCCESS';
export const PUT_ME_FAILURE = 'PUT_ME_FAILURE';

export const CLEAR_ME_DATA = 'CLEAR_ME_DATA';

export const GET_USER_LIST_REQUEST = 'GET_USER_LIST_REQUEST';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';

export const GET_USER_SINGLE_REQUEST = 'GET_USER_SINGLE_REQUEST';
export const GET_USER_SINGLE_SUCCESS = 'GET_USER_SINGLE_SUCCESS';
export const GET_USER_SINGLE_FAILURE = 'GET_USER_SINGLE_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const GET_ORDER_LIST_REQUEST = 'GET_ORDER_LIST_REQUEST';
export const GET_ORDER_LIST_SUCCESS = 'GET_ORDER_LIST_SUCCESS';
export const GET_ORDER_LIST_FAILURE = 'GET_ORDER_LIST_FAILURE';

export const GET_ORDER_SINGLE_REQUEST = 'GET_ORDER_SINGLE_REQUEST';
export const GET_ORDER_SINGLE_SUCCESS = 'GET_ORDER_SINGLE_SUCCESS';
export const GET_ORDER_SINGLE_FAILURE = 'GET_ORDER_SINGLE_FAILURE';

export const POST_ORDER_STATUS_REQUEST = 'POST_ORDER_STATUS_REQUEST';
export const POST_ORDER_STATUS_SUCCESS = 'POST_ORDER_STATUS_SUCCESS';
export const POST_ORDER_STATUS_FAILURE = 'POST_ORDER_STATUS_FAILURE';

export const POST_ORDER_STATUS_MULTIPLE_REQUEST = 'POST_ORDER_STATUS_MULTIPLE_REQUEST';
export const POST_ORDER_STATUS_MULTIPLE_SUCCESS = 'POST_ORDER_STATUS_MULTIPLE_SUCCESS';
export const POST_ORDER_STATUS_MULTIPLE_FAILURE = 'POST_ORDER_STATUS_MULTIPLE_FAILURE';

export const GET_ORDER_DOC_REQUEST = 'GET_ORDER_DOC_REQUEST';
export const GET_ORDER_DOC_SUCCESS = 'GET_ORDER_DOC_SUCCESS';
export const GET_ORDER_DOC_FAILURE = 'GET_ORDER_DOC_FAILURE';

export const POST_ORDER_DOC_MULTIPLE_REQUEST = 'POST_ORDER_DOC_MULTIPLE_REQUEST';
export const POST_ORDER_DOC_MULTIPLE_SUCCESS = 'POST_ORDER_DOC_MULTIPLE_SUCCESS';
export const POST_ORDER_DOC_MULTIPLE_FAILURE = 'POST_ORDER_DOC_MULTIPLE_FAILURE';

export const POST_ORDER_RECONCILE_REQUEST = 'POST_ORDER_RECONCILE_REQUEST';
export const POST_ORDER_RECONCILE_SUCCESS = 'POST_ORDER_RECONCILE_SUCCESS';
export const POST_ORDER_RECONCILE_FAILURE = 'POST_ORDER_RECONCILE_FAILURE';

export const GET_STOCK_BROWSER_SKU_LIST_REQUEST = 'GET_STOCK_BROWSER_SKU_LIST_REQUEST';
export const GET_STOCK_BROWSER_SKU_LIST_SUCCESS = 'GET_STOCK_BROWSER_SKU_LIST_SUCCESS';
export const GET_STOCK_BROWSER_SKU_LIST_FAILURE = 'GET_STOCK_BROWSER_SKU_LIST_FAILURE';

export const GET_SKU_SINGLE_REQUEST = 'GET_SKU_SINGLE_REQUEST';
export const GET_SKU_SINGLE_SUCCESS = 'GET_SKU_SINGLE_SUCCESS';
export const GET_SKU_SINGLE_FAILURE = 'GET_SKU_SINGLE_FAILURE';

export const PUT_PRODUCT_STOCK_REQUEST = 'PUT_PRODUCT_STOCK_REQUEST';
export const PUT_PRODUCT_STOCK_SUCCESS = 'PUT_PRODUCT_STOCK_SUCCESS';
export const PUT_PRODUCT_STOCK_FAILURE = 'PUT_PRODUCT_STOCK_FAILURE';

export const GET_SKU_BRANCH_LIST_REQUEST = 'GET_SKU_BRANCH_LIST_REQUEST';
export const GET_SKU_BRANCH_LIST_SUCCESS = 'GET_SKU_BRANCH_LIST_SUCCESS';
export const GET_SKU_BRANCH_LIST_FAILURE = 'GET_SKU_BRANCH_LIST_FAILURE';

export const GET_BRAND_LIST_REQUEST = 'GET_BRAND_LIST_REQUEST';
export const GET_BRAND_LIST_SUCCESS = 'GET_BRAND_LIST_SUCCESS';
export const GET_BRAND_LIST_FAILURE = 'GET_BRAND_LIST_FAILURE';

export const GET_BRANCHES_LIST_REQUEST = 'GET_BRANCHES_LIST_REQUEST';
export const GET_BRANCHES_LIST_SUCCESS = 'GET_BRANCHES_LIST_SUCCESS';
export const GET_BRANCHES_LIST_FAILURE = 'GET_BRANCHES_LIST_FAILURE';

export const GET_BRANCHES_SINGLE_REQUEST = 'GET_BRANCHES_SINGLE_REQUEST';
export const GET_BRANCHES_SINGLE_SUCCESS = 'GET_BRANCHES_SINGLE_SUCCESS';
export const GET_BRANCHES_SINGLE_FAILURE = 'GET_BRANCHES_SINGLE_FAILURE';

export const GET_BRANCHES_SKU_LIST_REQUEST = 'GET_BRANCHES_SKU_LIST_REQUEST';
export const GET_BRANCHES_SKU_LIST_SUCCESS = 'GET_BRANCHES_SKU_LIST_SUCCESS';
export const GET_BRANCHES_SKU_LIST_FAILURE = 'GET_BRANCHES_SKU_LIST_FAILURE';

export const GET_LOCATION_LIST_REQUEST = 'GET_LOCATION_LIST_REQUEST';
export const GET_LOCATION_LIST_SUCCESS = 'GET_LOCATION_LIST_SUCCESS';
export const GET_LOCATION_LIST_FAILURE = 'GET_LOCATION_LIST_FAILURE';

export const GET_CHANNEL_LIST_REQUEST = 'GET_CHANNEL_LIST_REQUEST';
export const GET_CHANNEL_LIST_SUCCESS = 'GET_CHANNEL_LIST_SUCCESS';
export const GET_CHANNEL_LIST_FAILURE = 'GET_CHANNEL_LIST_FAILURE';

export const GET_CHANNEL_SINGLE_REQUEST = 'GET_CHANNEL_SINGLE_REQUEST';
export const GET_CHANNEL_SINGLE_SUCCESS = 'GET_CHANNEL_SINGLE_SUCCESS';
export const GET_CHANNEL_SINGLE_FAILURE = 'GET_CHANNEL_SINGLE_FAILURE';

export const UPDATE_CHANNEL_REQUEST = 'UPDATE_CHANNEL_REQUEST';
export const UPDATE_CHANNEL_SUCCESS = 'UPDATE_CHANNEL_SUCCESS';
export const UPDATE_CHANNEL_FAILURE = 'UPDATE_CHANNEL_FAILURE';

export const DELETE_CHANNEL_REQUEST = 'DELETE_CHANNEL_REQUEST';
export const DELETE_CHANNEL_SUCCESS = 'DELETE_CHANNEL_SUCCESS';
export const DELETE_CHANNEL_FAILURE = 'DELETE_CHANNEL_FAILURE';

export const CREATE_CHANNEL_REQUEST = 'CREATE_CHANNEL_REQUEST';
export const CREATE_CHANNEL_SUCCESS = 'CREATE_CHANNEL_SUCCESS';
export const CREATE_CHANNEL_FAILURE = 'CREATE_CHANNEL_FAILURE';

export const GET_CATEGORY_LIST_REQUEST = 'GET_CATEGORY_LIST_REQUEST';
export const GET_CATEGORY_LIST_SUCCESS = 'GET_CATEGORY_LIST_SUCCESS';
export const GET_CATEGORY_LIST_FAILURE = 'GET_CATEGORY_LIST_FAILURE';

export const CHECKED_CATEGORY = 'CHECKED_CATEGORY';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';

export const CLEAR_ALL_CHECKED = 'CLEAR_ALL_CHECKED';
export const CLEAR_ALL_SELECTED = 'CLEAR_ALL_SELECTED';

export const POST_STOCK_RULE_REQUEST = 'POST_STOCK_RULE_REQUEST';
export const POST_STOCK_RULE_SUCCESS = 'POST_STOCK_RULE_SUCCESS';
export const POST_STOCK_RULE_FAILURE = 'POST_STOCK_RULE_FAILURE';

export const GET_STOCK_RULE_LIST_REQUEST = 'GET_STOCK_RULE_LIST_REQUEST';
export const GET_STOCK_RULE_LIST_SUCCESS = 'GET_STOCK_RULE_LIST_SUCCESS';
export const GET_STOCK_RULE_LIST_FAILURE = 'GET_STOCK_RULE_LIST_FAILURE';

export const GET_STOCK_RULE_SINGLE_REQUEST = 'GET_STOCK_RULE_SINGLE_REQUEST';
export const GET_STOCK_RULE_SINGLE_SUCCESS = 'GET_STOCK_RULE_SINGLE_SUCCESS';
export const GET_STOCK_RULE_SINGLE_FAILURE = 'GET_STOCK_RULE_SINGLE_FAILURE';

export const PUT_STOCK_RULE_REQUEST = 'PUT_STOCK_RULE_REQUEST';
export const PUT_STOCK_RULE_SUCCESS = 'PUT_STOCK_RULE_SUCCESS';
export const PUT_STOCK_RULE_FAILURE = 'PUT_STOCK_RULE_FAILURE';

export const DELETE_STOCK_RULE_REQUEST = 'DELETE_STOCK_RULE_REQUEST';
export const DELETE_STOCK_RULE_SUCCESS = 'DELETE_STOCK_RULE_SUCCESS';
export const DELETE_STOCK_RULE_FAILURE = 'DELETE_STOCK_RULE_FAILURE';

export const GET_CHANNEL_RULE_LIST_REQUEST = 'GET_CHANNEL_RULE_LIST_REQUEST';
export const GET_CHANNEL_RULE_LIST_SUCCESS = 'GET_CHANNEL_RULE_LIST_SUCCESS';
export const GET_CHANNEL_RULE_LIST_FAILURE = 'GET_CHANNEL_RULE_LIST_FAILURE';

export const GET_CHANNEL_RULE_SINGLE_REQUEST = 'GET_CHANNEL_RULE_SINGLE_REQUEST';
export const GET_CHANNEL_RULE_SINGLE_SUCCESS = 'GET_CHANNEL_RULE_SINGLE_SUCCESS';
export const GET_CHANNEL_RULE_SINGLE_FAILURE = 'GET_CHANNEL_RULE_SINGLE_FAILURE';

export const POST_CHANNEL_RULE_REQUEST = 'POST_CHANNEL_RULE_REQUEST';
export const POST_CHANNEL_RULE_SUCCESS = 'POST_CHANNEL_RULE_SUCCESS';
export const POST_CHANNEL_RULE_FAILURE = 'POST_CHANNEL_RULE_FAILURE';

export const PUT_CHANNEL_RULE_REQUEST = 'PUT_CHANNEL_RULE_REQUEST';
export const PUT_CHANNEL_RULE_SUCCESS = 'PUT_CHANNEL_RULE_SUCCESS';
export const PUT_CHANNEL_RULE_FAILURE = 'PUT_CHANNEL_RULE_FAILURE';

export const DELETE_CHANNEL_RULE_REQUEST = 'DELETE_CHANNEL_RULE_REQUEST';
export const DELETE_CHANNEL_RULE_SUCCESS = 'DELETE_CHANNEL_RULE_SUCCESS';
export const DELETE_CHANNEL_RULE_FAILURE = 'DELETE_CHANNEL_RULE_FAILURE';

export const GET_BRANCH_GROUP_LIST_REQUEST = 'GET_BRANCH_GROUP_LIST_REQUEST';
export const GET_BRANCH_GROUP_LIST_SUCCESS = 'GET_BRANCH_GROUP_LIST_SUCCESS';
export const GET_BRANCH_GROUP_LIST_FAILURE = 'GET_BRANCH_GROUP_LIST_FAILURE';

export const GET_BRANCH_GROUP_ASSIGN_LIST_REQUEST = 'GET_BRANCH_GROUP_ASSIGN_LIST_REQUEST';
export const GET_BRANCH_GROUP_ASSIGN_LIST_SUCCESS = 'GET_BRANCH_GROUP_ASSIGN_LIST_SUCCESS';
export const GET_BRANCH_GROUP_ASSIGN_LIST_FAILURE = 'GET_BRANCH_GROUP_ASSIGN_LIST_FAILURE';

export const POST_BRANCH_GROUP_ASSIGN_REQUEST = 'POST_BRANCH_GROUP_ASSIGN_REQUEST';
export const POST_BRANCH_GROUP_ASSIGN_SUCCESS = 'POST_BRANCH_GROUP_ASSIGN_SUCCESS';
export const POST_BRANCH_GROUP_ASSIGN_FAILURE = 'POST_BRANCH_GROUP_ASSIGN_FAILURE';

export const GET_DASHBOARD_PRODUCT_STATUS_REQUEST = 'GET_DASHBOARD_PRODUCT_STATUS_REQUEST';
export const GET_DASHBOARD_PRODUCT_STATUS_SUCCESS = 'GET_DASHBOARD_PRODUCT_STATUS_SUCCESS';
export const GET_DASHBOARD_PRODUCT_STATUS_FAILURE = 'GET_DASHBOARD_PRODUCT_STATUS_FAILURE';

export const GET_DASHBOARD_PRODUCT_OVERVIEW_REQUEST = 'GET_DASHBOARD_PRODUCT_OVERVIEW_REQUEST';
export const GET_DASHBOARD_PRODUCT_OVERVIEW_SUCCESS = 'GET_DASHBOARD_PRODUCT_OVERVIEW_SUCCESS';
export const GET_DASHBOARD_PRODUCT_OVERVIEW_FAILURE = 'GET_DASHBOARD_PRODUCT_OVERVIEW_FAILURE';

export const GET_DASHBOARD_STOCK_STATUS_REQUEST = 'GET_DASHBOARD_STOCK_STATUS_REQUEST';
export const GET_DASHBOARD_STOCK_STATUS_SUCCESS = 'GET_DASHBOARD_STOCK_STATUS_SUCCESS';
export const GET_DASHBOARD_STOCK_STATUS_FAILURE = 'GET_DASHBOARD_STOCK_STATUS_FAILURE';

export const GET_DASHBOARD_FAST_MOVE_REQUEST = 'GET_DASHBOARD_FAST_MOVE_REQUEST';
export const GET_DASHBOARD_FAST_MOVE_SUCCESS = 'GET_DASHBOARD_FAST_MOVE_SUCCESS';
export const GET_DASHBOARD_FAST_MOVE_FAILURE = 'GET_DASHBOARD_FAST_MOVE_FAILURE';

export const GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';

export const GET_STOCK_REPORT_REQUEST = 'GET_STOCK_REPORT_REQUEST';
export const GET_STOCK_REPORT_SUCCESS = 'GET_STOCK_REPORT_SUCCESS';
export const GET_STOCK_REPORT_FAILURE = 'GET_STOCK_REPORT_FAILURE';

export const GET_ERROR_REQUEST = 'GET_ERROR_REQUEST';
export const GET_ERROR_SUCCESS = 'GET_ERROR_SUCCESS';
export const GET_ERROR_FAILURE = 'GET_ERROR_FAILURE';

export const POST_RESOLVE_ERROR_REQUEST = 'POST_RESOLVE_ERROR_REQUEST';
export const POST_RESOLVE_ERROR_SUCCESS = 'POST_RESOLVE_ERROR_SUCCESS';
export const POST_RESOLVE_ERROR_FAILURE = 'POST_RESOLVE_ERROR_FAILURE';

export const GET_ALLOCATION_CHANNEL_RULE_LIST_REQUEST = 'GET_ALLOCATION_CHANNEL_RULE_LIST_REQUEST';
export const GET_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS = 'GET_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS';
export const GET_ALLOCATION_CHANNEL_RULE_LIST_FAILURE = 'GET_ALLOCATION_CHANNEL_RULE_LIST_FAILURE';

export const POST_ALLOCATION_CHANNEL_RULE_LIST_REQUEST = 'POST_ALLOCATION_CHANNEL_RULE_LIST_REQUEST';
export const POST_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS = 'POST_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS';
export const POST_ALLOCATION_CHANNEL_RULE_LIST_FAILURE = 'POST_ALLOCATION_CHANNEL_RULE_LIST_FAILURE';

export const GET_ALLOCATION_STOCK_RULE_LIST_REQUEST = 'GET_ALLOCATION_STOCK_RULE_LIST_REQUEST';
export const GET_ALLOCATION_STOCK_RULE_LIST_SUCCESS = 'GET_ALLOCATION_STOCK_RULE_LIST_SUCCESS';
export const GET_ALLOCATION_STOCK_RULE_LIST_FAILURE = 'GET_ALLOCATION_STOCK_RULE_LIST_FAILURE';

export const POST_ALLOCATION_STOCK_RULE_LIST_REQUEST = 'POST_ALLOCATION_STOCK_RULE_LIST_REQUEST';
export const POST_ALLOCATION_STOCK_RULE_LIST_SUCCESS = 'POST_ALLOCATION_STOCK_RULE_LIST_SUCCESS';
export const POST_ALLOCATION_STOCK_RULE_LIST_FAILURE = 'POST_ALLOCATION_STOCK_RULE_LIST_FAILURE';

export const GET_AUDIT_LOGS_REQUEST = 'GET_AUDIT_LOGS_REQUEST';
export const GET_AUDIT_LOGS_SUCCESS = 'GET_AUDIT_LOGS_SUCCESS';
export const GET_AUDIT_LOGS_FAILURE = 'GET_AUDIT_LOGS_FAILURE';

export const GET_AUDIT_LOG_REQUEST = 'GET_AUDIT_LOG_REQUEST';
export const GET_AUDIT_LOG_SUCCESS = 'GET_AUDIT_LOG_SUCCESS';
export const GET_AUDIT_LOG_FAILURE = 'GET_AUDIT_LOG_FAILURE';

export const GET_AUDIT_LOG_OPTION_REQUEST = 'GET_AUDIT_LOG_OPTION_REQUEST';
export const GET_AUDIT_LOG_OPTION_SUCCESS = 'GET_AUDIT_LOG_OPTION_SUCCESS';
export const GET_AUDIT_LOG_OPTION_FAILURE = 'GET_AUDIT_LOG_OPTION_FAILURE';